import { render, staticRenderFns } from "./text-tip.vue?vue&type=template&id=0b14e0ce"
import script from "./text-tip.vue?vue&type=script&setup=true&lang=js"
export * from "./text-tip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./text-tip.vue?vue&type=style&index=0&id=0b14e0ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports